import * as React from "react";

import {
  Box,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
} from "@mui/material";
import { visuallyHidden } from "@mui/utils";
import { useTheme } from "@material-ui/core";

function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort, headCells, visibleColumns } = props;

  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };
  const theme = useTheme();
  return (
    <TableHead style={{ position: "sticky", top: 0, zIndex: 8 }}>
      <TableRow>
        <TableCell scope="row" className="stickyCell stickyFirst"></TableCell>
        {headCells
          .filter((col) => visibleColumns[col.id])
          .map((headCell, index) => {
            // decide sticky class
            const classes = [""]; // default no class
            // if (index === 0) classes.push("stickyCell", "stickyFirst"); // 1st col
            if (index === 0) classes.push("stickyCell", "stickySecond"); // 2nd col
            // if (index === 1) classes.push("stickyCell", "stickyThird"); // 3rd col
            if (headCell.id === "action") classes.push("stickyCell", "stickyLast"); // last col by id

            return headCell?.activeIndexOnly ? (
              <TableCell
                key={index}
                align={headCell.align}
                padding={headCell.disablePadding ? "none" : "normal"}
                sortDirection={orderBy === headCell.id ? order : false}
                className={classes.join(" ")}
                sx={{ background: theme.palette.thead, color: theme.palette.listItem }}
              >
                <TableSortLabel
                  active={orderBy === headCell.id}
                  disabled={!headCell.sortable}
                  direction={orderBy === headCell.id ? order : "asc"}
                  onClick={createSortHandler(headCell.id)}
                  sx={{
                    '&.Mui-active': {
                      color: theme.palette.listItem, // Change this to your desired active color
                    },
                    '& .MuiTableSortLabel-icon': {
                      color: theme.palette.listItem, // Icon color
                    }

                  }}
                >
                  {headCell.label}
                  {orderBy === headCell.id ? (
                    <Box sx={visuallyHidden}>
                      {order === "desc" ? "sorted descending" : "sorted ascending"}
                    </Box>
                  ) : null}
                </TableSortLabel>
              </TableCell>
            ) : (
              <TableCell
                key={index}
                align={headCell.align}
                padding={headCell.disablePadding ? "none" : "normal"}
                sortDirection={orderBy === headCell.id ? order : false}
                className={classes.join(" ")}
              >
                <TableSortLabel
                  active={orderBy === headCell.id}
                  disabled={!headCell.sortable}
                  direction={orderBy === headCell.id ? order : "asc"}
                  onClick={createSortHandler(headCell.id)}
                  sx={{
                    '&.Mui-active': {
                      color: theme.palette.listItem, // Change this to your desired active color
                    },
                    '& .MuiTableSortLabel-icon': {
                      color: theme.palette.listItem, // Icon color
                    }

                  }}
                >
                  {headCell.label}
                  {orderBy === headCell.id ? (
                    <Box component="span" sx={visuallyHidden}>
                      {order === "desc" ? "sorted descending" : "sorted ascending"}
                    </Box>
                  ) : null}
                </TableSortLabel>
              </TableCell>
            );
          })}
      </TableRow>
    </TableHead>
  );
}

export default EnhancedTableHead;
